import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Text } from "@nextui-org/react";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import * as Yup from "yup";
import { noop } from "../../../helpers";
import { Checkbox, Input } from "../../controls/formik-wrapped";
import { List } from "./list";
import styles from "./skills-editor.module.less";
// const DEFAULT_SKILL_GROUP_VALUE: SkillGroup = {
//   name: "",
// }
var DEFAULT_SKILL_VALUE = {
  name: "",
  additional: false
};

var compareValues = function compareValues(a, b) {
  if (a === undefined || b === undefined) return false;
  if (a === b) return true;
  var allKeys = Array.from(new Set([].concat(_toConsumableArray(Object.keys(a)), _toConsumableArray(Object.keys(b)))));
  var matches = allKeys.reduce(function (matched, key) {
    return matched && a[key] === b[key];
  }, true);
  console.log({
    allKeys: allKeys,
    a: a,
    b: b,
    matches: matches
  });
  return matches;
}; // const compareValueArray = (a: (Skill | undefined)[] | undefined, b: (Skill | undefined)[] | undefined) => {
//   if (a?.length !== b?.length) return false
//   if (!a || !b) return false
//   if (a === b) return true
//   return a.every((value, index) => value === b[index])
// }


var aggregateErrors = function aggregateErrors(errors) {
  return Object.values(errors).reduce(function (errs, err) {
    return err ? [].concat(_toConsumableArray(errs), [err]) : errs;
  }, []);
};

var SingleSkill = function SingleSkill(_ref) {
  var initialValue = _ref.initialValue,
      onValueChanged = _ref.onValueChanged;

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      isValid = _useState4[0],
      setIsValid = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      validReason = _useState6[0],
      setValidReason = _useState6[1];

  var previousValue = useRef(initialValue);
  var validationSchema = useMemo(function () {
    var schema = Yup.object({
      name: Yup.string().ensure().trim().required(),
      aliases: Yup.string().optional(),
      rating: Yup.number().optional(),
      groups: Yup.array().of(Yup.string()).optional(),
      additional: Yup.bool().optional(),
      details: Yup.array().of(Yup.string()).optional(),
      related: Yup.array().of(Yup.string()).optional()
    });
    return schema;
  }, []);
  useEffect(function () {
    if (isValid === undefined) return;
    if (compareValues(previousValue.current, currentValue)) return;
    previousValue.current = currentValue;

    if (isValid) {
      onValueChanged(currentValue);
    }
  }, [currentValue, isValid, onValueChanged, validReason]);
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValue !== null && initialValue !== void 0 ? initialValue : _objectSpread({}, DEFAULT_SKILL_VALUE),
    validationSchema: validationSchema,
    onSubmit: function onSubmit(_values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;
      setSubmitting(false);
    }
  }, function (_ref3) {
    var isValid = _ref3.isValid,
        values = _ref3.values,
        errors = _ref3.errors;
    setIsValid(isValid);
    if (isValid && !compareValues(currentValue, values)) setCurrentValue(values);
    var aggregatedErrors = aggregateErrors(errors);
    setValidReason(aggregatedErrors.length ? aggregatedErrors.join("; ") : undefined);
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Input, {
      label: "Skill",
      name: "name",
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "name",
      component: "div"
    }), /*#__PURE__*/React.createElement(Checkbox, {
      className: styles.checkbox,
      name: "additional",
      label: "Show in Additional Skills",
      size: "sm"
    }));
  });
};

var DisplaySingleSkill = function DisplaySingleSkill(_ref4) {
  var initialValue = _ref4.initialValue;
  return /*#__PURE__*/React.createElement(Text, null, (initialValue === null || initialValue === void 0 ? void 0 : initialValue.name) || "Unknown skill");
};

var EditSingleSkillHeader = function EditSingleSkillHeader(_ref5) {
  var initialValue = _ref5.initialValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, null, (initialValue === null || initialValue === void 0 ? void 0 : initialValue.name) || "Skill"));
};

export var SkillsEditor = function SkillsEditor(_ref6) {
  var _ref6$skills = _ref6.skills,
      skills = _ref6$skills === void 0 ? [] : _ref6$skills,
      onValueChanged = _ref6.onValueChanged;
  // const onValuesChanged = useCallback(
  //   (skills: (Skill | undefined)[]) => {
  //     const filteredSkills = skills.filter((skill) => !!skill) as Skill[]
  //     onValueChanged(filteredSkills)
  //   },
  //   [onValueChanged]
  // )
  return /*#__PURE__*/React.createElement(List, {
    individuallyEdit: true,
    display: DisplaySingleSkill,
    editHeader: EditSingleSkillHeader,
    input: SingleSkill,
    newItem: function newItem() {
      return _objectSpread({}, DEFAULT_SKILL_VALUE);
    },
    values: skills || [],
    onValueAdded: noop,
    onValueChanged: noop,
    onValuesChanged: onValueChanged
  });
};